export const environment = {
    apiUrl: 'https://api.staging.digicoffer.com/professional',
    apiUrlHealth:'https://healthcare.adminapi.digicoffer.com',
    queryUrl: 'https://adminapi.staging.digicoffer.com',
    doc2pdf:"https://prod.utils.doc2pdf.digicoffer.com/api/v1/doc2pdf",
    DOC2FILE :'https://prod.utils.doc2pdf.digicoffer.com/api/v1/docfile2pdf',
    product: 'admin_console',
    production: false
};